import ColorStyles from '@Styles/colors.scss';
import { CheckboxProps, Checkbox as MuiCheckbox } from '@mui/material';
import { styled } from '@mui/system';
import React from 'react';

const StyledCheckbox = styled(MuiCheckbox)({
    padding: '0px',
    '& .MuiSvgIcon-root': {
        // Customize the SVG icon inside the checkbox
        padding: '0px',
        color: '#E0E3E7',
        height: '18px',
        width: '18px',
        borderRadius: '0px',
    },
    '&.Mui-checked': {
        // Customize the checked state of the checkbox
        color: 'white',
        '& .MuiSvgIcon-root': {
            fill: 'white',
            backgroundColor: '#1A1E2C',
        },
    },
    '&.MuiTypography-root': {
        color: 'red',
    },
});

const Checkbox = (props) => {
    return <StyledCheckbox {...props} />;
};

export default Checkbox;
